import React, { ReactNode } from "react";
import Img from "images/benifitsection.png";

type CardProps = {
  title: string;
  description: string;
  className?: string;
  icon: ReactNode;
};

// SVG Components for each card

const BenefitsSection: React.FC = () => {
  return (
    <section className="bg-black text-white p-4 sm:p-6 md:p-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-start">
        <div className="mb-8 lg:mb-0">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
            Where Are You Going?
          </h2>
          <div className="rounded-lg overflow-hidden">
            <img
              src={Img}
              alt="Car rental location"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          <div className="sm:translate-y-0 md:translate-y-8 lg:translate-y-12">
            <Card
              title="Pick-Up Location"
              description="Choose your most convenient pickup location."
              icon={
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="60" height="60" rx="30" fill="#F5F5F7" />
                  <path
                    d="M25.4205 36.154C24.6272 36.154 23.9085 35.9393 23.2645 35.51C22.6205 35.0807 22.1119 34.4833 21.7385 33.718C21.3745 32.9433 21.1925 32.052 21.1925 31.044C21.1925 30.0267 21.3745 29.14 21.7385 28.384C22.1025 27.6187 22.6019 27.026 23.2365 26.606C23.8712 26.1767 24.5899 25.962 25.3925 25.962C26.2045 25.962 26.9279 26.1767 27.5625 26.606C28.1972 27.026 28.6965 27.6187 29.0605 28.384C29.4339 29.1493 29.6205 30.0407 29.6205 31.058C29.6205 32.0753 29.4339 32.9667 29.0605 33.732C28.6965 34.4973 28.1972 35.0947 27.5625 35.524C26.9372 35.944 26.2232 36.154 25.4205 36.154ZM25.4065 34.208C25.8172 34.208 26.1719 34.0913 26.4705 33.858C26.7692 33.6153 26.9979 33.2607 27.1565 32.794C27.3245 32.318 27.4085 31.7393 27.4085 31.058C27.4085 30.3673 27.3245 29.7887 27.1565 29.322C26.9979 28.8553 26.7692 28.5053 26.4705 28.272C26.1719 28.0293 25.8125 27.908 25.3925 27.908C24.9912 27.908 24.6365 28.0247 24.3285 28.258C24.0299 28.4913 23.8012 28.8413 23.6425 29.308C23.4839 29.7747 23.4045 30.3533 23.4045 31.044C23.4045 31.7347 23.4839 32.3133 23.6425 32.78C23.8012 33.2467 24.0299 33.6013 24.3285 33.844C24.6365 34.0867 24.9959 34.208 25.4065 34.208ZM32.2528 36V26.116H34.4368V36H32.2528ZM30.3488 27.978V26.116H34.2968V27.978H30.3488ZM37.4598 36.154C37.0958 36.154 36.7924 36.028 36.5498 35.776C36.3071 35.524 36.1858 35.2207 36.1858 34.866C36.1858 34.4927 36.3071 34.1847 36.5498 33.942C36.7924 33.69 37.0958 33.564 37.4598 33.564C37.8331 33.564 38.1364 33.69 38.3698 33.942C38.6124 34.1847 38.7338 34.4927 38.7338 34.866C38.7338 35.2207 38.6124 35.524 38.3698 35.776C38.1364 36.028 37.8331 36.154 37.4598 36.154Z"
                    fill="url(#paint0_linear_2056_3375)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2056_3375"
                      x1="20.5801"
                      y1="22"
                      x2="43.2723"
                      y2="31.6509"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD700" />
                      <stop offset="1" stop-color="#B8860B" />
                    </linearGradient>
                  </defs>
                </svg>
              }
            />
          </div>
          <div>
            <Card
              title="Drop-Off Options"
              description="Same drop-off or a different location—it's up to you!"
              icon={
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="60" height="60" rx="30" fill="#F5F5F7" />
                  <path
                    d="M23.5442 36.154C22.7508 36.154 22.0322 35.9393 21.3882 35.51C20.7442 35.0807 20.2355 34.4833 19.8622 33.718C19.4982 32.9433 19.3162 32.052 19.3162 31.044C19.3162 30.0267 19.4982 29.14 19.8622 28.384C20.2262 27.6187 20.7255 27.026 21.3602 26.606C21.9948 26.1767 22.7135 25.962 23.5162 25.962C24.3282 25.962 25.0515 26.1767 25.6862 26.606C26.3208 27.026 26.8202 27.6187 27.1842 28.384C27.5575 29.1493 27.7442 30.0407 27.7442 31.058C27.7442 32.0753 27.5575 32.9667 27.1842 33.732C26.8202 34.4973 26.3208 35.0947 25.6862 35.524C25.0608 35.944 24.3468 36.154 23.5442 36.154ZM23.5302 34.208C23.9408 34.208 24.2955 34.0913 24.5942 33.858C24.8928 33.6153 25.1215 33.2607 25.2802 32.794C25.4482 32.318 25.5322 31.7393 25.5322 31.058C25.5322 30.3673 25.4482 29.7887 25.2802 29.322C25.1215 28.8553 24.8928 28.5053 24.5942 28.272C24.2955 28.0293 23.9362 27.908 23.5162 27.908C23.1148 27.908 22.7602 28.0247 22.4522 28.258C22.1535 28.4913 21.9248 28.8413 21.7662 29.308C21.6075 29.7747 21.5282 30.3533 21.5282 31.044C21.5282 31.7347 21.6075 32.3133 21.7662 32.78C21.9248 33.2467 22.1535 33.6013 22.4522 33.844C22.7602 34.0867 23.1195 34.208 23.5302 34.208ZM28.5284 34.768L32.3224 30.848C32.5557 30.6147 32.7424 30.4 32.8824 30.204C33.0224 30.008 33.125 29.826 33.1904 29.658C33.2557 29.4807 33.2884 29.3033 33.2884 29.126C33.2884 28.7433 33.1624 28.4447 32.9104 28.23C32.6677 28.006 32.3457 27.894 31.9444 27.894C31.5524 27.894 31.1977 28.0013 30.8804 28.216C30.5724 28.4213 30.2737 28.762 29.9844 29.238L28.5144 27.964C28.9064 27.3013 29.4057 26.802 30.0124 26.466C30.619 26.13 31.3144 25.962 32.0984 25.962C32.7797 25.962 33.3677 26.088 33.8624 26.34C34.3664 26.592 34.7537 26.9513 35.0244 27.418C35.3044 27.8847 35.4444 28.4307 35.4444 29.056C35.4444 29.448 35.393 29.812 35.2904 30.148C35.1877 30.4747 35.0197 30.8013 34.7864 31.128C34.5624 31.4453 34.259 31.7953 33.8764 32.178L31.2444 34.796L28.5284 34.768ZM28.5284 36V34.768L30.3904 34.124H35.6404V36H28.5284ZM38.1947 36.154C37.8307 36.154 37.5274 36.028 37.2847 35.776C37.0421 35.524 36.9207 35.2207 36.9207 34.866C36.9207 34.4927 37.0421 34.1847 37.2847 33.942C37.5274 33.69 37.8307 33.564 38.1947 33.564C38.5681 33.564 38.8714 33.69 39.1047 33.942C39.3474 34.1847 39.4687 34.4927 39.4687 34.866C39.4687 35.2207 39.3474 35.524 39.1047 35.776C38.8714 36.028 38.5681 36.154 38.1947 36.154Z"
                    fill="url(#paint0_linear_2056_3378)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2056_3378"
                      x1="18.5801"
                      y1="26"
                      x2="35.9397"
                      y2="41.274"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD700" />
                      <stop offset="1" stop-color="#B8860B" />
                    </linearGradient>
                  </defs>
                </svg>
              }
            />
          </div>
          <div className="sm:translate-y-0 md:translate-y-8 lg:translate-y-12">
            <Card
              title="Add Dates"
              description="Customize your rental with pick-up and drop-off times."
              icon={
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="60" height="60" rx="30" fill="#F5F5F7" />
                  <path
                    d="M23.7424 36.154C22.9491 36.154 22.2304 35.9393 21.5864 35.51C20.9424 35.0807 20.4337 34.4833 20.0604 33.718C19.6964 32.9433 19.5144 32.052 19.5144 31.044C19.5144 30.0267 19.6964 29.14 20.0604 28.384C20.4244 27.6187 20.9237 27.026 21.5584 26.606C22.1931 26.1767 22.9117 25.962 23.7144 25.962C24.5264 25.962 25.2497 26.1767 25.8844 26.606C26.5191 27.026 27.0184 27.6187 27.3824 28.384C27.7557 29.1493 27.9424 30.0407 27.9424 31.058C27.9424 32.0753 27.7557 32.9667 27.3824 33.732C27.0184 34.4973 26.5191 35.0947 25.8844 35.524C25.2591 35.944 24.5451 36.154 23.7424 36.154ZM23.7284 34.208C24.1391 34.208 24.4937 34.0913 24.7924 33.858C25.0911 33.6153 25.3197 33.2607 25.4784 32.794C25.6464 32.318 25.7304 31.7393 25.7304 31.058C25.7304 30.3673 25.6464 29.7887 25.4784 29.322C25.3197 28.8553 25.0911 28.5053 24.7924 28.272C24.4937 28.0293 24.1344 27.908 23.7144 27.908C23.3131 27.908 22.9584 28.0247 22.6504 28.258C22.3517 28.4913 22.1231 28.8413 21.9644 29.308C21.8057 29.7747 21.7264 30.3533 21.7264 31.044C21.7264 31.7347 21.8057 32.3133 21.9644 32.78C22.1231 33.2467 22.3517 33.6013 22.6504 33.844C22.9584 34.0867 23.3177 34.208 23.7284 34.208ZM31.9326 36.154C31.2513 36.154 30.626 36.0373 30.0566 35.804C29.4873 35.5613 29.0066 35.216 28.6146 34.768L30.0286 33.354C30.206 33.6153 30.4626 33.83 30.7986 33.998C31.144 34.1567 31.508 34.236 31.8906 34.236C32.236 34.236 32.5346 34.1753 32.7866 34.054C33.0386 33.9327 33.2346 33.76 33.3746 33.536C33.524 33.312 33.5986 33.046 33.5986 32.738C33.5986 32.43 33.524 32.1687 33.3746 31.954C33.2346 31.73 33.0246 31.5573 32.7446 31.436C32.474 31.3147 32.1473 31.254 31.7646 31.254C31.5873 31.254 31.4006 31.268 31.2046 31.296C31.018 31.3147 30.8593 31.3473 30.7286 31.394L31.6946 30.176C31.956 30.1013 32.2033 30.0407 32.4366 29.994C32.6793 29.938 32.9033 29.91 33.1086 29.91C33.6126 29.91 34.0653 30.0313 34.4666 30.274C34.868 30.5073 35.1853 30.8433 35.4186 31.282C35.6613 31.7113 35.7826 32.2247 35.7826 32.822C35.7826 33.4753 35.6193 34.054 35.2926 34.558C34.9753 35.062 34.5273 35.454 33.9486 35.734C33.3793 36.014 32.7073 36.154 31.9326 36.154ZM30.7286 31.394V30.176L33.1366 27.348L35.6006 27.334L33.0946 30.19L30.7286 31.394ZM29.2306 27.978V26.116H35.6006V27.334L33.8786 27.978H29.2306ZM37.9965 36.154C37.6325 36.154 37.3292 36.028 37.0865 35.776C36.8438 35.524 36.7225 35.2207 36.7225 34.866C36.7225 34.4927 36.8438 34.1847 37.0865 33.942C37.3292 33.69 37.6325 33.564 37.9965 33.564C38.3698 33.564 38.6732 33.69 38.9065 33.942C39.1492 34.1847 39.2705 34.4927 39.2705 34.866C39.2705 35.2207 39.1492 35.524 38.9065 35.776C38.6732 36.028 38.3698 36.154 37.9965 36.154Z"
                    fill="url(#paint0_linear_2056_3381)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2056_3381"
                      x1="18.5801"
                      y1="26"
                      x2="35.9397"
                      y2="41.274"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD700" />
                      <stop offset="1" stop-color="#B8860B" />
                    </linearGradient>
                  </defs>
                </svg>
              }
            />
          </div>
          <div>
            <Card
              title="Pick-Up – Drop-Off"
              description="10:00 AM - 05:00 PM"
              className="bg-gradient-to-r from-[#d4af372b] to-[#ffd70013]"
              icon={
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="60" height="60" rx="30" fill="#F5F5F7" />
                  <path
                    d="M23.4143 36.154C22.6209 36.154 21.9023 35.9393 21.2583 35.51C20.6143 35.0807 20.1056 34.4833 19.7323 33.718C19.3683 32.9433 19.1863 32.052 19.1863 31.044C19.1863 30.0267 19.3683 29.14 19.7323 28.384C20.0963 27.6187 20.5956 27.026 21.2303 26.606C21.8649 26.1767 22.5836 25.962 23.3863 25.962C24.1983 25.962 24.9216 26.1767 25.5563 26.606C26.1909 27.026 26.6903 27.6187 27.0543 28.384C27.4276 29.1493 27.6143 30.0407 27.6143 31.058C27.6143 32.0753 27.4276 32.9667 27.0543 33.732C26.6903 34.4973 26.1909 35.0947 25.5563 35.524C24.9309 35.944 24.2169 36.154 23.4143 36.154ZM23.4003 34.208C23.8109 34.208 24.1656 34.0913 24.4643 33.858C24.7629 33.6153 24.9916 33.2607 25.1503 32.794C25.3183 32.318 25.4023 31.7393 25.4023 31.058C25.4023 30.3673 25.3183 29.7887 25.1503 29.322C24.9916 28.8553 24.7629 28.5053 24.4643 28.272C24.1656 28.0293 23.8063 27.908 23.3863 27.908C22.9849 27.908 22.6303 28.0247 22.3223 28.258C22.0236 28.4913 21.7949 28.8413 21.6363 29.308C21.4776 29.7747 21.3983 30.3533 21.3983 31.044C21.3983 31.7347 21.4776 32.3133 21.6363 32.78C21.7949 33.2467 22.0236 33.6013 22.3223 33.844C22.6303 34.0867 22.9896 34.208 23.4003 34.208ZM28.3565 32.57L31.6045 26.116H33.9985L30.6805 32.57H28.3565ZM28.3565 33.802V32.57L29.0845 31.94H36.2805V33.802H28.3565ZM33.0185 36V29.882H35.1745V36H33.0185ZM38.3246 36.154C37.9606 36.154 37.6573 36.028 37.4146 35.776C37.1719 35.524 37.0506 35.2207 37.0506 34.866C37.0506 34.4927 37.1719 34.1847 37.4146 33.942C37.6573 33.69 37.9606 33.564 38.3246 33.564C38.6979 33.564 39.0013 33.69 39.2346 33.942C39.4773 34.1847 39.5986 34.4927 39.5986 34.866C39.5986 35.2207 39.4773 35.524 39.2346 35.776C39.0013 36.028 38.6979 36.154 38.3246 36.154Z"
                    fill="url(#paint0_linear_2056_3384)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2056_3384"
                      x1="18.5801"
                      y1="26"
                      x2="35.9397"
                      y2="41.274"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD700" />
                      <stop offset="1" stop-color="#B8860B" />
                    </linearGradient>
                  </defs>
                </svg>
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Card: React.FC<CardProps> = ({ title, description, className, icon }) => {
  return (
    <div
      className={`bg-transparent p-4 sm:p-5 md:p-6 rounded-lg border border-[#d4af37] shadow-md flex flex-col justify-between min-h-[180px] sm:min-h-[200px] md:min-h-60 ${className}`}
    >
      <div className="space-y-3 md:space-y-4">
        <div className="flex items-center justify-center sm:justify-start">
          {icon}
        </div>
        <div>
          <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">
            {title}
          </h3>

          <p className="text-sm sm:text-base text-gray-400">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
